if (!customElements.get('card-promo')) {
  customElements.define(
    'card-promo',
    class CardPromo extends HTMLElement {
      connectedCallback() {
        this.evaluate();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      evaluate() {
        clearTimeout(this.timer);
        const now = Date.now();
        const start = (parseInt(this.dataset.start, 10) || 0) * 1000;
        const end = (parseInt(this.dataset.end, 10) || 0) * 1000;
        const preview = new URLSearchParams(window.location.search).has('promo_preview');
        const active = preview || (now >= start && now < end);

        this.hidden = !active;
        this.classList.toggle('is-active', active);

        // If a start or end boundary occurs while the page is open, re-check then.
        if (!preview) {
          const next = now < start ? start : now < end ? end : null;
          if (next && next - now < 86400000) {
            this.timer = setTimeout(() => this.evaluate(), next - now + 1000);
          }
        }
      }
    }
  );
}